import React from 'react';
import _ from 'lodash';

import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
  TextInput,
  FormElementContainer,
} from '../CommonFormComponents';
import { BackgroundLayer } from '../modals/BackgroundLayer';
import { CcusConnectingDialog } from '../modals/CcusConnectingDialog';
import { ButtonCcus, CcusDescription } from '../CcusBase';
import { Description } from '../Description';

import { messageUtility } from '../../utilities/messageUtility';
import { TAB_KEY_STATUS } from '../../utilities/constants';

export const CcusAdminForm = ({
  data,
  connectCcus,
  setValue,
  editPage,
  messageValidate,
  ccusStatus,
  isLoadingCcus,
  isShowPass,
  toggleShowPassword,
  checkValidate,
  ccusStateManagementId,
  messageNG,
  isLoadingData,
  isOwner,
}) => {
  const {
    ccus_company_admin_id,
    ccus_company_admin_password,
    ccus_company_admin_name,
    last_connected_at,
  } = data;

  return (
    <div className='CcusForm'>
      <FormList>
        <FormListSubHeader title='その他の管理者情報' noMarginTop={true} />
        <FormElementContainer style={{ maxWidth: '1024px' }}>
          <CcusDescription>
            <div>
              {isOwner && messageUtility.getMessage('I-001-456')}
              {!isOwner && !editPage && messageUtility.getMessage('I-001-519')}
              {!isOwner && editPage && messageUtility.getMessage('I-001-520')}
            </div>
          </CcusDescription>
          <Description style={{ marginBottom: '8px' }}>
            <div>
              {isOwner
                ? messageUtility.getMessage('I-001-457')
                : messageUtility.getMessage('I-001-518')}
            </div>
          </Description>
        </FormElementContainer>
        <FormListItem label='CCUS管理者ID' required={true} className='form-list__item form-list__item--ccus-admin-form'>
          <FormElement
            validate={_.get(messageValidate, 'ccus_company_admin_id')}
          >
            <TextInput
              tabIndex={
                isLoadingCcus ? TAB_KEY_STATUS.disabled : TAB_KEY_STATUS.enabled
              }
              disabled={false}
              type='text'
              name='ccus_company_admin_id'
              value={ccus_company_admin_id}
              onChange={e => setValue(e, 'ccus_company_admin_id')}
              onBlur={e => checkValidate(e, 'ccus_company_admin_id')}
            />
          </FormElement>
        </FormListItem>
        {editPage ? (
          <React.Fragment>
            <FormListItem
              label={
                isOwner ? 'CCUSログインパスワード' : 'CCUSセキュリティコード'
              }
              className='form-list__item form-list__item--ccus-admin-form'
            >
              <FormElement>
                <label>
                  <input
                    type='checkbox'
                    value={isShowPass}
                    onChange={() => toggleShowPassword(isShowPass)}
                  />
                  {isOwner
                    ? 'パスワードを編集する'
                    : 'セキュリティコードを編集する'}
                </label>
              </FormElement>
            </FormListItem>
            {isShowPass && (
              <FormListItem
                label={
                  isOwner
                    ? 'パスワード・セキュリティコード'
                    : 'CCUSセキュリティコード'
                }
                required={true}
                className='form-list__item form-list__item-admin-password'
              >
                <FormElement
                  validate={_.get(
                    messageValidate,
                    'ccus_company_admin_password'
                  )}
                >
                  <TextInput
                    tabIndex={
                      isLoadingCcus
                        ? TAB_KEY_STATUS.disabled
                        : TAB_KEY_STATUS.enabled
                    }
                    disabled={false}
                    type='password'
                    value={ccus_company_admin_password}
                    name='ccus_company_admin_password'
                    onChange={e => setValue(e, 'ccus_company_admin_password')}
                    onBlur={e =>
                      checkValidate(e, 'ccus_company_admin_password')
                    }
                  />
                </FormElement>
              </FormListItem>
            )}
          </React.Fragment>
        ) : (
          <FormListItem
            label={
              isOwner ? 'CCUSログインパスワード' : 'CCUSセキュリティコード'
            }
            required={true}
            className='form-list__item form-list__item--ccus-admin-form'
          >
            <FormElement
              validate={_.get(messageValidate, 'ccus_company_admin_password')}
            >
              <TextInput
                tabIndex={
                  isLoadingCcus
                    ? TAB_KEY_STATUS.disabled
                    : TAB_KEY_STATUS.enabled
                }
                disabled={false}
                type='password'
                autoComplete='new-password'
                name='ccus_company_admin_password'
                value={ccus_company_admin_password}
                onChange={e => setValue(e, 'ccus_company_admin_password')}
                onBlur={e => checkValidate(e, 'ccus_company_admin_password')}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListItem label='表示名' required={true} className='form-list__item form-list__item--ccus-admin-form'>
          <FormElement
            validate={_.get(messageValidate, 'ccus_company_admin_name')}
          >
            <TextInput
              tabIndex={
                isLoadingCcus ? TAB_KEY_STATUS.disabled : TAB_KEY_STATUS.enabled
              }
              disabled={false}
              type='text'
              name='ccus_company_admin_name'
              value={ccus_company_admin_name}
              onChange={e => setValue(e, 'ccus_company_admin_name')}
              onBlur={e => checkValidate(e, 'ccus_company_admin_name')}
            />
            <div className='text-description'>
              この項目はBuildeeの画面上に表示するためだけに使用します。わかりやすい名前を設定してください。
            </div>
          </FormElement>
        </FormListItem>
        <FormListItem label='連携状態' className='form-list__item form-list__item--ccus-admin-form'>
          <FormElement>
            <ButtonCcus
              lastConnection={last_connected_at}
              onClick={() => connectCcus(data)}
              ccusStatus={ccusStatus}
              ccusStateManagementId={ccusStateManagementId}
              messageNG={messageNG}
              editPage={editPage}
              isLoadingData={isLoadingData}
              isOwner={isOwner}
            />
          </FormElement>
        </FormListItem>
        {isLoadingCcus && (
          <BackgroundLayer modalRoot='root' modalState={true}>
            {isLoadingCcus && <CcusConnectingDialog />}
          </BackgroundLayer>
        )}
      </FormList>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/CcusAdminForm.jsx